/**
 * i18n setup for the employee portal.
 *
 * Languages: Magyar (hu) · English (en) · Nepali (ne — Latin script)
 * Persisted in localStorage under "portal_lang".
 */
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import hu from "./locales/hu.json";
import en from "./locales/en.json";
import ne from "./locales/ne.json";

const STORAGE_KEY = "portal_lang";

function detectLang() {
  if (typeof window === "undefined") return "hu";
  const stored = window.localStorage.getItem(STORAGE_KEY);
  if (stored && ["hu", "en", "ne"].includes(stored)) return stored;
  return "hu";
}

i18n
  .use(initReactI18next)
  .init({
    resources: {
      hu: { translation: hu },
      en: { translation: en },
      ne: { translation: ne },
    },
    lng: detectLang(),
    fallbackLng: "hu",
    interpolation: { escapeValue: false },
    returnNull: false,
  });

export function setPortalLanguage(lang) {
  if (!["hu", "en", "ne"].includes(lang)) return;
  i18n.changeLanguage(lang);
  try {
    window.localStorage.setItem(STORAGE_KEY, lang);
  } catch (e) {
    /* noop */
  }
}

export const PORTAL_LANGUAGES = [
  { code: "hu", label: "Magyar", flag: "🇭🇺" },
  { code: "en", label: "English", flag: "🇬🇧" },
  { code: "ne", label: "Nepali", flag: "🇳🇵" },
];

export default i18n;
